"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
exports.styles = {
    categoryName: {
        fontWeight: 500,
    },
    rootNode: {
        textTransform: 'uppercase',
        '&.rollup': {
            background: '#fff0f3',
            width: 'inherit',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 5,
        },
    },
};
